"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2743],{

/***/ 72743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ domain_ApplicationCommons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/domain/Analytics/index.js + 10 modules
var Analytics = __webpack_require__(50492);
;// CONCATENATED MODULE: ./src/domain/ApplicationCommons/ApplicationCommons.js


var isDevelopment = "production" !== "production";
function ApplicationCommons() {
    if (isDevelopment) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Analytics/* default */.Z, {})
    });
};

;// CONCATENATED MODULE: ./src/domain/ApplicationCommons/index.js

/* harmony default export */ var domain_ApplicationCommons = (ApplicationCommons);


/***/ })

}]);